import React from 'react';

import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const CustomDevelopedLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'custom_audiences' },
        linkBackLabel: 'Your Custom Audiences',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Built to reach audiences defined by project-based insights, this segment utilizes data beyond standard attributes to meet strategic objectives.'
            }
            title={'Custom Developed'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/custom developed-banner.png'}
        />
    );
};

export default CustomDevelopedLayout;
